module.exports = __webpack_public_path__ + "static/media/dem_pre_ste.942346d0.png";